import { BeatEventType } from '@wix/thunderbolt-symbols'
import { instance } from '../bi-module/instance'

instance.sendBeat(BeatEventType.PARTIALLY_VISIBLE, 'Partially visible', { pageId: window.firstPageId })
